import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useDispatch } from '@grandvisionhq/state';
import '@grandvisionhq/utils';
import '@grandvisionhq/carts-v2';
import { selectShippingMethod, toggleDeliveryAddress } from '../../../actions.js';
import '../../../selectors.js';
import 'lodash/isEmpty';
import '../../../../mappers/errors-mapping.js';
import '../../../../utils/get-customer-details-payload.js';
import '../../../../models/cart/cart-state.js';
import '../../../../models/checkout/checkout-step-error-type.js';
import '../../../../models/checkout-settings.js';
import { ShippingMethod } from '../../../../models/step-shipping/shipping-methods.js';
import '../../../../models/shared.js';
import 'history';
import '../../../../utils/has-cart-errors.js';
import '@grandvisionhq/payments';
import '@grandvisionhq/auth';
import '../../../../context/CheckoutSettings/context.js';
import '../../../../selectors.js';
import '@grandvisionhq/common';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../../../../operations/mutations/set-customer-details.js';
import '../../../../operations/mutations/set-service-store.js';
import '../../../../operations/mutations/set-shipping-method.js';
import '../../../../operations/mutations/set-shipping-state.js';
import '../../../../operations/mutations/create-apple-pay-session.js';
import '../../../../operations/mutations/recreate-ordered-checkout.js';
import { useSetShippingMethod } from '../../../../hooks/operations/use-set-shipping-method.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../../../../operations/fragments/checkout-mutation-result.js';
import '../../../../operations/fragments/cart-mutation-failures.js';
import '../../../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../../../operations/fragments/paypal-payment.js';
import '../../../../operations/fragments/saved-user-details.js';
import '../../../../operations/queries/get-checkout-state.js';
import '../../../../operations/queries/get-user-details.js';

const useShippingMethodSelection = ({ onError , onSuccess , shippingMethodList ,  })=>{
    const dispatch = useDispatch();
    /**
   *  Error callback for setShippingMethod mutation
   */ const onShippingMethodError = React.useCallback(()=>{
        onError && onError('MUTATION');
    }, [
        onError
    ]);
    const handleOnShippingMethodSelectionCompleted = React.useCallback((_, shippingMethodKey)=>{
        dispatch(selectShippingMethod({
            shippingMethod: {
                method: shippingMethodKey,
                isValid: true,
                isTouched: true
            }
        }));
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(shippingMethodKey);
    }, [
        dispatch,
        onSuccess
    ]);
    const { setShippingMethod , setSelectedShippingMethod  } = useSetShippingMethod({
        onError: onShippingMethodError,
        onCompleted: handleOnShippingMethodSelectionCompleted
    });
    /**
   * Shipping method selection handler
   * @arguments method: string
   */ const handleChange = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(method, globalStoreId) {
            if (!shippingMethodList || shippingMethodList.length < 0) {
                throw new Error('No shipping methods available!');
            }
            const shippingMethod = shippingMethodList.find((item)=>item.key === method
            );
            if (!shippingMethod) {
                console.warn('Partially unsupported shipping method selected, attempting to select it');
            } else {
                if (method === ShippingMethod.Pickup && !globalStoreId) {
                    console.warn('Global Store ID is required for Pickup ');
                    return;
                }
                setSelectedShippingMethod && setSelectedShippingMethod(method);
                if (method !== ShippingMethod.Delivery && method !== ShippingMethod.DeliveryExpress) {
                    dispatch(toggleDeliveryAddress({
                        enabled: false
                    }));
                }
                // We dispatch it for store pickup as soon as the store is selected as we also need to pass the globalStoreId
                if (globalStoreId) {
                    yield setShippingMethod(shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.id, globalStoreId);
                } else {
                    yield setShippingMethod(shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.id);
                }
            }
        });
        return function(method, globalStoreId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        shippingMethodList,
        setSelectedShippingMethod,
        dispatch,
        setShippingMethod
    ]);
    return {
        handleOnShippingMethodSelected: handleChange
    };
};

export { useShippingMethodSelection };
//# sourceMappingURL=use-shipping-method-selection.js.map
